import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import AppRoutes from './AppRoutes';
import { SessionProvider } from './contexts/SessionContext';
import ErrorBoundary from './components/ErrorBoundary';

function App() {
  return (
    <Router>
      <SessionProvider>
        <ErrorBoundary>
          <AppRoutes />
        </ErrorBoundary>
        <Analytics />
      </SessionProvider>
    </Router>
  );
}

export default App;
